import { css, styled } from '@volkswagen-onehub/components-core';

export const ChartContainer = styled.div`
	display: flex;
	align-items: center;
`;

export const ChartWrapper = styled.div`
	width: ${({ theme }: { theme: any }) => theme.size.static520};
	height: ${({ theme }: { theme: any }) => theme.size.static520};
`;

const circle = css`
	stroke-dashoffset: 0;
	fill: transparent;
	transition: stroke-dashoffset 500ms cubic-bezier(0.165, 0.84, 0.44, 1);
`;

export const CircleBackground = styled.circle`
	${circle}
	stroke: ${({ theme }: { theme: any }) => theme.colors.border.divider};
`;

export const Circle = styled.circle<{ printOffset?: number }>`
	${circle}
	stroke: #0040c5;

	@media print {
		stroke-dashoffset: ${({ printOffset }: { printOffset?: number }) => printOffset};
	}
`;
